import { Title } from "react-admin";
import { Grid, Paper } from "@mui/material";

import { EmptyList } from "server/components";

import TemplateCard from "./Partials/TemplateCard";
import { useBusinessTripTemplates } from "./useBusinessTripTemplates";

// The whole catalogue — a stable empty object keeps the hook's effect from re-firing.
const ALL_TEMPLATES = {};

const BusinessTripReportsPage = () => {
  const { templates, loading } = useBusinessTripTemplates(ALL_TEMPLATES);

  if (loading) return null;
  if (!templates.length) return <EmptyList />;

  return (
    <>
      <Title title="Бланки за командировки" />
      <Paper sx={{ p: 2 }}>
        <Grid
          container
          spacing={2}
        >
          {templates.map(template => (
            <TemplateCard
              key={template?.documentId}
              template={template}
            />
          ))}
        </Grid>
      </Paper>
    </>
  );
};

export default BusinessTripReportsPage;
